import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      d: "M18.204 21.466c-.183-.163-.61.509-.386 1.038.122.325.997.753 2.014.203l.025-.014c1.328 1.179 2.971 1.56 4.147 1.56 1.178 0 2.814-.383 4.137-1.565l.035.02c.997.549 1.872.121 2.014-.204.204-.53-.203-1.2-.386-1.038-.306.254-.58.322-.821.29q.268-.366.495-.799c.224-.427 0-.651-.264-.793-.285-.123-.631-.407-.814-.59.325.325.264.549.04.915a7 7 0 0 1-.425.633c-.43-.43-.857-1.142-.45-1.63.04-.061.081-.102.122-.143a2 2 0 0 0-.224.204c-.162.163-.529.346-.753.509-.284.183-.223.488-.122.732.216.47.431.842.674 1.144-.874.768-1.945 1.156-3.258 1.156-1.314 0-2.385-.388-3.26-1.158.24-.301.45-.672.655-1.142.122-.244.183-.55-.102-.732-.223-.163-.59-.346-.752-.509-.082-.081-.163-.142-.224-.204.04.041.081.082.122.143.404.485-.014 1.19-.458 1.618a7 7 0 0 1-.417-.62c-.224-.367-.285-.591.02-.917a2.8 2.8 0 0 1-.814.59c-.264.143-.488.367-.264.794q.227.434.497.8c-.235.028-.503-.041-.803-.291"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      d: "M20.24 20.815c-.041-.204-.306-.122-.387.122a3.3 3.3 0 0 1-.285-.448c-.244-.366-.285-.61.06-.956.164-.163.49-.346.713-.143.468.387.224 1.018-.102 1.425m7.51 0c.04-.204.325-.122.407.122.101-.143.203-.285.285-.448.244-.366.284-.61-.082-.956-.142-.163-.468-.346-.712-.143-.448.387-.224 1.018.102 1.425m-9.931 1.689c-.204-.306-.366-1.1-.407-1.303-.061-.183-.082-.346.142-.427s.428.203.53.448c.101.244.264.61.447 1.058-.448-.265-.814-.082-.712.224m12.372 0c.183-.306.346-1.1.407-1.303.041-.183.082-.346-.142-.427s-.427.203-.53.448c-.101.244-.264.61-.447 1.058.448-.265.794-.082.712.224"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      d: "m23.572 7.987.447.577.43-.505.154.457s.339-.265.48-.4c-.097.205-.2.512-.29.815.188-.256.436-.473.779-.631-.218.217-.665 1.229-.665 1.229.28-.353.729-.815 1.418-1.087a13 13 0 0 0-1.22 1.455c.361-.338.898-.758 1.464-.946-.262.25-.682.672-1.037 1.033.352-.137.765-.242 1.098-.178-.281.105-1.526 1.039-1.526 1.039H22.94s-.916-1.04-1.152-1.182c.353.046.73.232 1.078.46-.343-.339-.778-.679-1.099-.847.367.027.743.197 1.1.407-.315-.411-.704-.76-.978-.915.4.064.767.284 1.086.56-.16-.304-.307-.599-.394-.764.182.149.471.284.846.82a5.7 5.7 0 0 0-.642-1.206c.22.09.578.478.578.478z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      d: "m26.34 11.509-.074.038a.333.333 0 0 0-.12.486l.073.104a.276.276 0 0 1-.217.433l-3.56.12a.33.33 0 0 1-.24-.09l-.358-.34a.33.33 0 0 1-.1-.297l.093-.549a.25.25 0 0 0-.18-.285l-.123-.035a.33.33 0 0 1-.158-.1l-.143-.16a.33.33 0 0 0-.25-.113h-.002a.071.071 0 0 1-.055-.117l.107-.128a.33.33 0 0 1 .257-.121h.402q.114.001.205.07l.138.107c.095.074.223.09.334.043l.52-.22 1.136-.146 1.38.29.946.562a.257.257 0 0 1-.012.448"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      d: "M22.438 13.285c-.265.061-.448.082-.692-.142-.163-.163-.122-.448.04-.55.184-.122.346-.203.57-.142s.814.61.672.63c-.143 0-.366.143-.59.204m.63-.976c.082-.061.183-.102.448-.122.244-.02.427-.02.488.162.082.224.143.489.306.61-.102.062-.61.123-.794.021-.244-.122-.305-.59-.448-.671m1.75.02c.082-.061.183-.061.448-.04s.366.04.427.223c.061.204 0 .468.122.651-.122.041-.529.041-.671-.101-.224-.163-.203-.631-.326-.733"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      d: "M25.653 12.451c.102.122.02.61.224.773.142.102.508.122.59-.101.102-.204.102-.51-.427-.672-.184-.04-.306-.061-.387 0m-1.71-.203c.061-.061.183-.082.428-.082.264 0 .427.04.508.204.082.203.061.468.204.63-.061.082-.61.082-.773-.04-.224-.143-.244-.61-.367-.713m-1.729.183c0-.101.142-.121.509-.142.366-.04.386-.02.508.244.061.143.143.387.306.469-.448.101-.59.162-.835.02-.183-.102-.386-.346-.427-.448-.02-.06-.02-.122-.061-.142"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      d: "M27.81 13.306v3.968c0 3.439-1.628 4.62-3.805 5.555-2.178-.936-3.826-2.116-3.826-5.555v-3.968z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      d: "M24.004 16.663c.184 0 .468-.162.713-.407.264-.284.712-.386 1.18 0 .468.387.753.224.997 0 .244-.223.448-.305.916-.305v-2.645h-7.631v2.645c.468 0 .671.082.915.305.245.224.53.387.998 0 .488-.386.915-.284 1.2 0 .224.245.509.407.712.407"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      d: "M24.004 18.698c.245 0 .733-.264.855-.325.448-.265.773-.02 1.038.101.285.123.814.265 1.14 0 .325-.264.508-.244.732-.244.04-.305.04-.61.04-.956v-.244c-.284-.061-.427.02-.732.285s-.65.203-1.099.04c-.427-.183-.854-.509-1.282 0-.122.143-.407.346-.692.346-.305 0-.57-.203-.691-.346-.448-.509-.855-.183-1.282 0-.448.163-.814.224-1.12-.04-.285-.265-.427-.346-.732-.285v.244c0 .346.02.651.06.956.225 0 .387-.02.713.244.326.265.875.123 1.14 0 .285-.122.61-.366 1.058-.101.122.06.59.325.855.325m-.001.875c.305 0 .672-.122.997-.305.407-.224.692-.122 1.1.081.427.204.773.143 1.017 0 .122-.08.224-.244.488-.183a4.6 4.6 0 0 1-.529 1.323c-.407.102-.63.102-1.058-.081-.427-.204-.957-.326-1.241-.143a1.55 1.55 0 0 1-.774.244 1.55 1.55 0 0 1-.773-.244c-.285-.183-.814-.06-1.241.143-.428.183-.652.183-1.059.081a4.6 4.6 0 0 1-.529-1.323c.265-.06.367.102.489.183.224.143.59.204.997 0 .427-.203.712-.305 1.12-.08.325.182.691.304.996.304m0 3.257c.814-.347 1.567-.733 2.177-1.262-.162-.061-.264-.02-.407-.122s-.57-.143-.936.06c-.386.184-.549.224-.834.224s-.448-.04-.834-.223c-.367-.204-.794-.163-.936-.061-.143.101-.245.06-.407.122.61.529 1.343.915 2.177 1.261"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M21.633 15.524a.3.3 0 0 1-.274-.001l-.063-.033a.247.247 0 0 0-.257.421l.102.072a.3.3 0 0 0 .251.044l1.597-.433 1.152-.482a.198.198 0 1 1 .116.376l-.306.063a.223.223 0 1 0 .12.427l.807-.292a.25.25 0 0 0 .166-.237c0-.154.136-.272.288-.25l.905.134a.17.17 0 0 1 .127.095l.01.022a.14.14 0 0 1-.054.18c-.1.06-.087.21.021.252l.16.064a.227.227 0 0 0 .311-.202l.022-.523a.18.18 0 0 0-.138-.182c-.201-.048-.176-.342.03-.354l.103-.007a.194.194 0 0 0 .183-.207l-.01-.162a.3.3 0 0 0-.205-.266l-.354-.118a.3.3 0 0 0-.14-.012l-1.26.194-.67.065a.085.085 0 1 1-.009-.17h.768a.233.233 0 0 0 .085-.448l-.04-.015a.26.26 0 0 0-.192.001l-.716.3a.255.255 0 0 0 .124.487l1.904-.197a.198.198 0 1 1 .012.394l-1.239-.055q-.027 0-.052.003l-1.105.145a.3.3 0 0 1-.338-.33l.025-.223a.3.3 0 0 0-.218-.322l-.61-.17a.3.3 0 0 0-.36.178l-.215.541a.3.3 0 0 1-.44.143l-.12-.077a.3.3 0 0 1-.122-.15l-.05-.131a.299.299 0 1 0-.465.337l.733.584a.3.3 0 0 1-.052.503z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M16 0v16H.003v-.017c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M4.288 2.403 8 6.114 14.065.05A57 57 0 0 1 16 0v1.886L9.886 8 16 14.114V16h-1.886L8 9.886 1.886 16H.003v-.017q-.013-.923.027-1.898L6.114 8 2.467 4.353a9 9 0 0 1 1.821-1.95",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M14.555.031Q15.276.007 16 0L8.472 7.529l-.708-.708zM3.308 3.307l4.22 4.222-.706.707-4.157-4.157c.194-.26.408-.52.643-.772M.003 16v-.003L7.53 8.47l.707.708L1.414 16zm8.469-7.529.707-.707L16 14.586V16z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M10 .399V16H6V1.372q.168-.075.342-.143C7.272.875 8.544.6 10 .4",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M1.529 6H16v4H.442q.172-1.061.424-2.125S1.035 7.072 1.53 6",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M9.334.498V16H6.667V1.114C7.403.867 8.312.662 9.334.498",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M1.246 6.667H16v2.666H.558q.135-.728.308-1.458s.102-.487.38-1.208",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagCym = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagCym_default = SvgFlagCym;

export { FlagCym_default as default };
